import { queryOptions } from '@tanstack/react-query'
import { apiExchange, apiGet, ApiError } from './client'
import { saveBytes } from './inventoree'

/**
 * ADM -> Impact, calea noua. Perechea veche, din
 * `application/controllers/Adm.php`:
 *
 *   impact($ciId) -> GET /adm/impact/{ciId}
 *
 * Calea NU poarta `/api/v2`: il pune `apiGet`.
 *
 * LA ECRANUL ASTA SE AJUNGE DIN TREI MODULE, si nu prin meniu, ci de pe fisa
 * unui lucru: Easeedesk (elementele afectate ale unui tichet), Inventoree (fisa
 * unui element de CMDB) si catalogul de servicii (compozitia si dependentele).
 * Toate trei scriu `adm/impact/<id>`, deci adresa e neschimbata.
 */

export interface ImpactCi {
  id: number
  name: string
  className: string
  companyName: string
  deviceName: string
  health: number
  healthLabel: string
}

export interface ImpactRow {
  ciId: number
  name: string
  className: string
  kind: number
  companyName: string
  /** `null` cand nimeni n-a pus o treapta - si atunci insigna scrie "not set". */
  criticality: number | null
  criticalityLabel: string
  /** 1 operational, 2 degraded, 3 down. Lipsa inseamna operational. */
  health: number
  healthLabel: string
  environment: number
  /** Cati pasi departe - cel mai apropiat drum. */
  depth: number
}

export interface ImpactSummary {
  total: number
  critical: number
  services: number
  companies: number
  byClass: { name: string; count: number }[]
}

export interface ImpactPage {
  pageTitle: string
  pageHeader: string
  breadcrumbs: string[]
  ci: ImpactCi
  summary: ImpactSummary
  affected: ImpactRow[]
  /** Butonul PDF apare numai daca serverul chiar poate scoate unul. */
  pdfAvailable: boolean
}

export function impactQuery(ciId: number) {
  return queryOptions({
    queryKey: ['adm', 'impact', ciId],
    queryFn: () => apiGet<ImpactPage>(`/adm/impact/${ciId}`),
  })
}

/** exportImpact - foaia cu aceleasi randuri ca ecranul (CI, Class, Company, Importance, Steps away). */
export async function downloadImpactXlsx(ciId: number): Promise<void> {
  const out = await apiExchange(`/adm/impact/${ciId}/export.xlsx`, { method: 'GET' })
  saveBytes(out.bytes, out.type, out.filename, `impact_${ciId}.xlsx`)
}

/**
 * exportImpactPdf - raza de explozie ca document, pentru consiliul de schimbare.
 * Cand serverul n-are cu ce s-o scoata raspunde 501 cu o propozitie, si aia se
 * arata - nu se salveaza un fisier care nu e un PDF.
 */
export async function downloadImpactPdf(ciId: number): Promise<void> {
  const out = await apiExchange(`/adm/impact/${ciId}/export.pdf`, { method: 'GET' })
  if (!out.type.includes('pdf')) {
    let message = 'The impact PDF could not be produced.'
    try {
      message = (JSON.parse(out.text) as { message?: string }).message ?? message
    } catch {
      /* Raspunsul nu era JSON; ramane propozitia de mai sus. */
    }
    throw new ApiError(out.status || 501, message)
  }
  saveBytes(out.bytes, out.type, out.filename, `impact_${ciId}.pdf`)
}
